<template>
  <div class="no-data show">게시물이 없어요</div>
</template>
